module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-17.76d63c65.jpg";